module.exports = __webpack_public_path__ + "7cfbd203d6e621b1459daeebb165f8db.svg";